import React from 'react';
import DefaultTransferMethod from '../components/PanelsComponents/DefaultPanels/DefaultTransferMethod';

//= ========================================================================
const Panel_F03_RequestPaymentTransferMethod = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onGotoEdit,
  onStepPressed,
  language,
}) => (
  <DefaultTransferMethod
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    onConfigChanged={onConfigChanged}
    onGotoEdit={onGotoEdit}
    onStepPressed={onStepPressed}
    language={language}
  />
);

export default Panel_F03_RequestPaymentTransferMethod;
